import React from "react";

interface SettingsSectionCardProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
}

export function SettingsSectionCard({
  title,
  description,
  children,
  className = "",
}: SettingsSectionCardProps) {
  return (
    <section
      className={`rounded-[20px] bg-surface-elevated p-6 ring-1 ring-white/[0.09] ${className}`}
    >
      <div className="text-[11px] font-black uppercase tracking-wide text-white/45">
        {title}
      </div>
      {description ? (
        <p className="mt-2 text-sm text-white/60">{description}</p>
      ) : null}
      <div className={description ? "mt-5" : "mt-4"}>{children}</div>
    </section>
  );
}
